import {useService} from '@cindedi/react-application';
import {truncate} from '@cindedi/utilities/truncate';
import type {MetaFunction, LoaderFunction} from '@remix-run/node';
import {json} from '@remix-run/node';
import {Link, useLoaderData} from '@remix-run/react';
import {PublicLayout} from '~/domains/organization/components/PublicLayout';
import {seoMeta} from '~/domains/organization/utilities/seoMeta';

export interface LinhasDePesquisaLoaderData {
  researchStreams: Research.PublicResearchStreamDto[];
}

export const meta: MetaFunction = function LinhasDePesquisaMeta({matches}) {
  return seoMeta('linhas-de-pesquisa', {title: 'Linhas de Pesquisa - Cindedi', description: 'Descubra as linhas de pesquisa do CINDEDI! Explore nossos estudos em desenvolvimento humano, educação infantil e muito mais.'}, matches);
};

export const loader: LoaderFunction = async function LinhasDePesquisaLoader({context: {use}}) {
  const ResearchStream = use('ResearchStream');

  const researchStreams = await ResearchStream.all();

  return json({
    researchStreams: researchStreams.sortBy('name'),
  });
};

export default function LinhasDePesquisaView() {
  const {researchStreams} = useLoaderData<LinhasDePesquisaLoaderData>();
  useService('organization/titlebar').setTitle('Linhas de Pesquisa');

  return (
    <PublicLayout>
      <ul role="list" className="flex flex-col gap-2">
        {researchStreams.map((researchStream) => (
          <li className="hover:bg-shade-3 bg-shade-2 rounded" key={researchStream.id}>
            <Link to={`/linhas-de-pesquisa/${researchStream.slug}`}>
              <div className="flex">
                <div className="px-2 py-2 flex flex-col w-full">
                  <span className="font-semibold text-primary-12">{researchStream.name}</span>
                  <span className="text-shade-11">
                    {truncate(researchStream.textDescription, 200)}
                  </span>
                </div>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </PublicLayout>
  );
}
